/* force-consistent brand breadcrumbs on vendor query pages */
(function () {
  const currentPath = window.location.pathname.toLowerCase();
  const currentQuery = new URLSearchParams(window.location.search);
  const vendorQuery = (currentQuery.get("q") || "").trim();

  if (currentPath === "/collections/vendors" && vendorQuery.toLowerCase() === "rvca") {
    window.location.replace("/collections/rvca");
    return;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getBrandName() {
    const heading = document.querySelector("main h1, .collection-banner h1, h1");
    if (heading && heading.textContent.trim()) {
      return heading.textContent.trim();
    }
    return vendorQuery.replace(/-/g, " ");
  }

  function fixVendorQueryBreadcrumb() {
    if (!document.body.classList.contains("template-collection")) return;
    if (currentPath !== "/collections/vendors" || !vendorQuery) return;

    const navs = document.querySelectorAll("nav[aria-label='breadcrumbs']");
    navs.forEach(function (nav) {
      if (nav.getAttribute("data-brand-breadcrumb-fixed") === "1") return;
      const homeLink = nav.querySelector("a");
      if (!homeLink) return;

      const brandName = getBrandName();
      nav.innerHTML =
        homeLink.outerHTML +
        '<i>/</i><a href="/pages/brands" title="Brand">Brand</a>' +
        "<i>/</i>" +
        escapeHtml(brandName);
      nav.setAttribute("data-brand-breadcrumb-fixed", "1");
    });
  }

  document.addEventListener("DOMContentLoaded", fixVendorQueryBreadcrumb);
  document.addEventListener("shopify:section:load", fixVendorQueryBreadcrumb);
  window.addEventListener("pageshow", fixVendorQueryBreadcrumb);
  setTimeout(fixVendorQueryBreadcrumb, 400);
})();


/*

function markSoldOutOptions() {
  console.log('checking options');

  const radioEls = document.querySelectorAll('input[name="Size"]');

  radioEls.forEach(radioEl => {
    if (radioEl.checked && radioEl.classList.contains("is-disabled")) {
      radioEl.setAttribute('checked', false);
      const firstAvailableRadio = Array.from(radioEls).find(input => 
        !input.classList.contains('is-disabled')
      );

      if (firstAvailableRadio) {
        firstAvailableRadio.setAttribute('checked', true);
      }

    }
  });
  
  // add sold out text to select options
  document.querySelectorAll('fieldset[data-handle="size"] option').forEach(optEl => {
    const soldOutText = ' (Sold out)';
    
    if (optEl.disabled) {
      // Add the label if missing
      if (!optEl.textContent.includes(soldOutText)) {
        optEl.textContent += soldOutText;
      }
    } else {
      // Remove the label if present
      if (optEl.textContent.includes(soldOutText)) {
        optEl.textContent = optEl.textContent.replace(soldOutText, '');
      }
    }
  });

}

// 1. Run it on page load
markSoldOutOptions();
*/
